<div
  class="wrapper"
  >
  @if (paginatedResultsList?.length) {
    <ng-container>
      @for (result of paginatedResultsList; track result; let last = $last) {
        <!-- All tab interleaves types, so each row names its category. -->
        @if (isAllTab) {
          <div class="result-category">{{ configFor(result)?.singularLabel }}</div>
        }
        @if (configFor(result)?.card === 'dailyReport') {
          <div class="daily-reports-list mb-[40px]">
            <app-daily-report-card
              [dailyReport]="result"
              class="daily-report-card"
              />
            <hr
              [class.last]="last"
              class="hr mb-[20px] w-[580px]"
              >
          </div>
        } @else if (configFor(result)?.card === 'issue') {
          <div class="issues-list mb-[40px]">
            <app-issue-card
              (click)="openResult(result)"
              [issue]="result" class="issue-card"
              />
          </div>
        } @else {
          <div class="results-list mb-[40px]">
            <app-search-result-card
              (click)="openResult(result)"
              [config]="configFor(result)"
              [result]="result"
              class="result-card"
              />
          </div>
        }
      }
    </ng-container>
  } @else {
    <div class="no-data flex justify-center items-center mb-[40px]">
      No data available for the current selection.
    </div>
  }
  @if (isServerTruncated) {
    <div class="server-truncation-note mb-[20px]">
      Showing the top {{ apiResultWindow }} matches for this category — refine
      your search to surface more specific results.
    </div>
  }
  @if (isAllTabCapped) {
    <div class="server-truncation-note mb-[20px]">
      Showing the top {{ allTabLimit }} matches across categories — open a
      category tab to see all of its results.
    </div>
  }
  <app-paginator
    (pageChanged)="onPageChanged($event)"
    [itemsPerPage]="itemsPerPage"
    [totalItems]="filterResultsList?.length"
    class="paginator"
    >
  </app-paginator>
</div>
